<script setup>
import { computed } from "vue";
import Icon from "@/components/Icon.vue";
import { useCrispChat } from "@/composables/useCrispChat";
import { mdiChatQuestionOutline } from "@mdi/js";

/*
 * The panel's own help button, bottom-right, where Crisp's bubble used to be.
 * Signed-in only: Crisp's bubble is hidden for signed-in customers
 * (installCrispLauncher in useCrispChat.js) so a new conversation always starts
 * from the dialog, with the instant answer from the tutorial first. Someone
 * with a conversation going, or unread replies, goes straight back to Crisp.
 */
const { openSupport, crispUnread } = useCrispChat();

const badge = computed(() => (crispUnread.value > 9 ? "9+" : String(crispUnread.value)));
const label = computed(() =>
  crispUnread.value > 0
    ? `Help and support, ${crispUnread.value} unread ${crispUnread.value === 1 ? "reply" : "replies"}`
    : "Help and support"
);
</script>

<template>
  <button
    type="button"
    class="fixed bottom-4 right-4 z-30 inline-flex h-14 w-14 items-center justify-center rounded-full bg-brand-600 text-white shadow-lg transition-colors hover:bg-brand-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-900"
    :aria-label="label"
    :title="label"
    data-testid="support-chat-button"
    @click="openSupport"
  >
    <icon :path="mdiChatQuestionOutline" :size="26" w="w-7" h="h-7" />
    <span
      v-if="crispUnread > 0"
      class="absolute -top-0.5 -right-0.5 inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-red-600 px-1 text-2xs font-semibold leading-none text-white ring-2 ring-white dark:ring-gray-900"
      aria-hidden="true"
    >
      {{ badge }}
    </span>
  </button>
</template>
